import Api from "../../../Api";

export const getShorexPackages = async (query) => {
  try {
    let res = await Api.get("/backoffice/shorex", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getShorexPackage = async (excId) => {
  try {
    let res = await Api.get("/backoffice/shorex/" + excId);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const updateShorexPackage = async (id, data) => {
  try {
    let res = await Api.patch("/backoffice/shorex/" + id, data);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const syncShorexExcursions = async (startDate, endDate, packageId) => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let res = await Api.post("/backoffice/shorex/sync-excursions", undefined, {
      params: { startDate, endDate, timezone, packageId },
    });
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Sync failed. Please try again." };
  }
};

export const getShorexBookings = async (query) => {
  try {
    let res = await Api.get("/backoffice/shorex/bookings", { params: query });
    return res?.data || { data: [], count: 0 };
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getShorexBookingPackageOptions = async () => {
  try {
    let res = await Api.get("/backoffice/shorex/bookings/package-options");
    return res?.data || { data: [] };
  } catch (e) {
    return { data: [] };
  }
};

export const getShorexBookingById = async (id) => {
  try {
    let res = await Api.get("/backoffice/shorex/bookings/" + id);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getShorexGuideLangStatus = async (vesselId) => {
  try {
    let res = await Api.get("/backoffice/shorex/guide-lang-status", {
      params: { vesselId },
    });
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const updateShorexGuideLangStatus = async (vesselId, guideLangEnabled) => {
  try {
    let res = await Api.patch("/backoffice/shorex/guide-lang-status", {
      vesselId,
      guideLangEnabled,
    });
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getShorexSalesReport = async (query) => {
  try {
    let res = await Api.get("/backoffice/shorex/report/sales", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getShorexSummaryReport = async (query) => {
  try {
    let res = await Api.get("/backoffice/shorex/report/summary", { params: query });
    return res?.data || { data: [], totalCount: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getShorexVoidReasons = async () => {
  try {
    let res = await Api.get("/backoffice/shorex/report/void-reasons");
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getShorexCurrentBusinessDate = async () => {
  try {
    let res = await Api.get("/backoffice/shorex/report/current-business-date");
    return res?.data || {};
  } catch (e) {
    return {};
  }
};

export const updateShorexBookingStatus = async (id, status, reason) => {
  try {
    let res = await Api.patch(`/backoffice/shorex/report/transactions/${id}/status`, {
      status,
      ...(reason ? { reason } : {}),
    });
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};
